export enum AppRoutes {
  HOME = "/",
  CHAT = "/chat",
  ASSISTANT_ID = ":assistantId",
  VOICE_CHAT = "/voice-chat",
  VOICE_ASSISTANT_ID = ":voiceAssistantId",
}
